var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRecommended(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 16.8268H12.5V33.0768H5C4.66848 33.0768 4.35054 32.9451 4.11612 32.7107C3.8817 32.4762 3.75 32.1583 3.75 31.8268V18.0768C3.75 17.7453 3.8817 17.4273 4.11612 17.1929C4.35054 16.9585 4.66848 16.8268 5 16.8268Z",
    stroke: "#999999",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 16.8268L18.75 4.32678C20.0761 4.32678 21.3479 4.85357 22.2855 5.79125C23.2232 6.72893 23.75 8.0007 23.75 9.32678V13.0768H33.4219C33.7764 13.0759 34.1269 13.1509 34.45 13.2967C34.7731 13.4426 35.0613 13.6558 35.2951 13.9222C35.529 14.1887 35.7031 14.502 35.8058 14.8413C35.9085 15.1806 35.9374 15.5379 35.8906 15.8893L34.0156 30.8893C33.9398 31.4914 33.6474 32.0454 33.1932 32.4479C32.7389 32.8504 32.1538 33.074 31.5469 33.0768H12.5",
    stroke: "#999999",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecommended);
export default __webpack_public_path__ + "static/media/recommended.6eafad150628fd0abd3194d3261f992a.svg";
export { ForwardRef as ReactComponent };